import { BrowserRouter } from 'react-router-dom';
import { GlobalProvider } from './context/globalContext';
import { LoginProvider } from './context/loginContext';
import { SnackbarProvider } from 'notistack';
import { CssBaseline } from '@mui/material';
import { ApplicationProvider } from './context/applicationContext';

const Root = ({ children }) => {
  return (
    <BrowserRouter>
      <SnackbarProvider
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}>
        <GlobalProvider>
          <LoginProvider>
            <ApplicationProvider>
              <CssBaseline />

              {children}
            </ApplicationProvider>
          </LoginProvider>
        </GlobalProvider>
      </SnackbarProvider>
    </BrowserRouter>
  );
};

export default Root;
